// can() — UX gating helper that mirrors the server-side rbacService check.
// Supports:
//   - exact match: 'finance.invoice.create' in list
//   - global wildcard: '*' grants everything
//   - prefix wildcard: 'finance.*' grants any 'finance.X', 'finance.X.Y', ...
//
// Server still enforces — this is purely for hiding/disabling UI affordances.

const matches = (granted, perm) => {
  if (granted === '*') return true;
  if (granted === perm) return true;
  if (granted.endsWith('.*') && perm.startsWith(granted.slice(0, -1))) return true;
  return false;
};

export const can = (permissions, permission) => {
  if (!permission) return true;
  if (!Array.isArray(permissions) || permissions.length === 0) return false;
  return permissions.some((g) => matches(g, permission));
};

export const canAny = (permissions, perms) => {
  if (!Array.isArray(perms) || perms.length === 0) return true;
  return perms.some((p) => can(permissions, p));
};

export const canAll = (permissions, perms) => {
  if (!Array.isArray(perms) || perms.length === 0) return true;
  return perms.every((p) => can(permissions, p));
};

export default can;
